import IconBox from "../../../../iconboxes/IconBox";
import { workerCompsATPPolicyStatusOptionsPayerTypes } from "../../../../../lib/systemData";

export default function WorkerCompDrawerSection({classes, drawerData = {}, goToCaseTabHandler}) {
    const row = drawerData ?? {}
    return <div className={classes.block}>
        <div className={classes.block_header}>
            <h3>Work Comp</h3>
            {row.worker_comp?.total && row.worker_comp?.total >=2 && <div className={classes.totals}>{row.worker_comp?.total}</div>}
            <button onClick={goToCaseTabHandler.bind(this, 6)}><i className='ti ti ti-arrow-up-right'></i></button>
        </div>
        <div className={classes.block_body}>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Carrier</div>
                <div className={classes.value}>{row.worker_comp?.insurance_carrier?.name}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Status</div>
                <div className={classes.value}>
                    {workerCompsATPPolicyStatusOptionsPayerTypes()?.find(item => item.value == row.worker_comp?.policy_status)?.label}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Adjuster</div>
                <div className={classes.value}>
                    {row.worker_comp?.adjuster && <>
                        <div>{row.worker_comp.adjuster.first_name} {row.worker_comp.adjuster.last_name}</div>
                        {row.worker_comp.adjuster.contact_information && row.worker_comp.adjuster.contact_information.phone && <IconBox type={'phone'} link={row.worker_comp.adjuster.contact_information.phone} workq={true}>
                            <i className="ti ti-phone"></i>
                        </IconBox>}
                    </>}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Nurse</div>
                <div className={classes.value}>
                    {row.worker_comp?.nurse && <>
                        <div>{row.worker_comp.nurse.first_name} {row.worker_comp.nurse.last_name}</div>
                        {row.worker_comp.nurse.contact_information && row.worker_comp.nurse.contact_information.phone && <IconBox type={'phone'} link={row.worker_comp.nurse.contact_information.phone} workq={true}>
                            <i className="ti ti-phone"></i>
                        </IconBox>}
                    </>}
                </div>
            </div>
            <div className={classes.block_body_row} >
                <div className={classes.label}>Last Appointment</div>
                <div className={classes.value}>{row.appointments?.last}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>NextAppointment</div>
                <div className={classes.value}>{row.appointments?.next}</div>
            </div>
        </div>
    </div>
}